import { ChangeDetectionStrategy, Component, HostListener, viewChild } from '@angular/core';
import { BsModalRef, BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { ControlPoint } from '../../bo/controlPoint';
import { Sismograph } from '../../bo/sismograph';
import { FonctionsService } from '../../services/fonctions-partagees.service';
import { HttpService } from '../../services/http.service';
import { UtilisateurService } from '../../services/utilisateur.service';
import { TraductionService } from '../../services/traduction.service';


@Component({
  selector: 'app-sismograph-control-point-modal',
  templateUrl: './sismograph-control-point-modal.component.html',
  styleUrls: ['./sismograph-control-point-modal.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SismographControlPointModalComponent {

  @HostListener('window:keydown.esc', ['$event'])
  onEsc(event: any): void {
    if (event.keyCode === 27) {
      event.preventDefault();
    }
    this.bsModalRef.hide();
  }


  readonly modalConfirmCancel = viewChild<ModalDirective>('modalConfirmCancel');
  modale: BsModalRef;
  listPoints: ControlPoint[] = [];
  sismograph: Sismograph;
  sismographSelected: Sismograph;
  controlPointSelected: ControlPoint;
  success = false;
  modif: boolean;
  buttonName: string;
  isAlert: boolean;


  constructor(
    public bsModalRef: BsModalRef, 
    private readonly http: HttpService,
    private readonly utilService: UtilisateurService,
    private readonly fonctionsService: FonctionsService,
    private readonly traductionService: TraductionService
       ) { }


  showModalCancel() {
    this.bsModalRef.hide();
  }

  createSismograph() {
    this.newSismograph();
    if (this.sismograph.equipementId === '' || this.sismograph.controlPointName === '' || this.sismograph.equipementId === null || this.sismograph.controlPointName === null || this.sismograph.controlPointName === undefined) {
      this.isAlert = true;
      return;
    };
      this.fonctionsService.loading_screen(true);

      this.http.post('Vibrations/' + this.utilService.currentSite().siteId + '/AddSismograph', this.sismograph).subscribe({
        next: (res:number) => {
          if(res > 0)
          this.fonctionsService.launch_toast(true);
        }, 
        error: error => {
          if (error.status === 409) {
            this.traductionService.translate.get('SISMOGRAPH.ERROR_DUPLICATE').subscribe(trad => {
            this.fonctionsService.launch_toast(false,false, trad);
            this.fonctionsService.loading_screen(false);
            this.bsModalRef.hide();
            });
          }
            this.fonctionsService.launch_toast(false);
            this.fonctionsService.loading_screen(false);
            this.bsModalRef.hide();
        }, complete: ()  =>{
          this.fonctionsService.loading_screen(false);
          this.bsModalRef.hide();
        }
      });
  }


  updateSismograph(){
    this.newSismograph();
    this.fonctionsService.loading_screen(true);
    this.http.put('Vibrations/' + this.utilService.currentSite().siteId + '/UpdateSismograph', this.sismograph).subscribe({
      next: (res:number) => {
        if(res > 0)
        this.fonctionsService.launch_toast(true);
      }, 
      error: error => {
        if (error.status === 409) {
          this.traductionService.translate.get('SISMOGRAPH.ERROR_DUPLICATE').subscribe(trad => {
            this.fonctionsService.launch_toast(false,false, trad);
            this.fonctionsService.loading_screen(false);
            this.bsModalRef.hide();
            });
        }
        this.fonctionsService.launch_toast(false);
        this.fonctionsService.loading_screen(false);
        this.bsModalRef.hide();
      }, complete: ()  =>{
        this.fonctionsService.loading_screen(false);
        this.bsModalRef.hide();
      }
    });
  }



  newSismograph() {
    this.sismograph = new Sismograph();
    this.sismograph = this.sismographSelected;
    this.sismograph.controlPointId = this.controlPointSelected.controlPointId;
    this.sismograph.controlPointName = this.controlPointSelected.name;
    this.sismograph.siteId = this.utilService.currentSite().siteId;
  }



  deleteSismograph(){
    this.fonctionsService.loading_screen(true);
    this.http.delete('Vibrations/' + this.utilService.currentSite().siteId + '/DeleteSismograph/?sismographEquipementId=' + this.sismographSelected.equipementId).subscribe((res:number)=>{
      if(res > 0)
      this.fonctionsService.launch_toast(true);
    }, (error) => {
        this.fonctionsService.launch_toast(false);
        this.fonctionsService.loading_screen(false);
        this.bsModalRef.hide();
    },() => {
      this.fonctionsService.loading_screen(false);
      this.bsModalRef.hide();
    })
  }

s





}
